<template>
	<div class="main-wrapper">
		<main class="main">
			<slot />
		</main>
	</div>
</template>

<style scoped lang="scss">
@layer hm-components
{
	.main-wrapper
	{
		outline:none;
		position:relative;
	}
	.main
	{
		min-height:1px;
	}
}
</style>
